// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/styles.css */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --primary-color: #1a237e;
  --secondary-color: #ff0000;
  --accent-color: #00bcd4;
  --light-color: #fafafa;
  --dark-color: #121858;
  --danger-color: #d32f2f;
  --success-color: #388e3c;
  --font-main: 'Arial', sans-serif;
}


body {
  font-family: var(--font-main);
  line-height: 1.6;
  color: #333;
  background-color: #f9f9f9;
}

/* Skip link for accessibility */
.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  z-index: 100;
  width: 100%;
  text-align: center;
  transition: top 0.3s;
}

.skip-to-content {
  background-color: var(--accent-color);
  color: white;
  padding: 8px 20px;
  text-decoration: none;
  border-radius: 0 0 5px 5px;
}

.skip-link:focus-within {
  top: 0;
}

.container {
  padding-inline: 32px;
  margin-inline: auto;
  max-width: 1300px;
}

/* Header styles */
header {
  background-color: var(--primary-color);
  color: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.main-header {
  min-height: 70px;
  padding-block: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
}

.brand-name {
  font-size: 1.5rem;
  font-weight: bold;
  text-decoration: none;
  color: white;
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-name i {
  font-size: 1.75rem;
}

/* Header actions styles */
.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}

/* Notification button styles */
.notification-button {
  background-color: var(--accent-color);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.notification-button:hover {
  background-color: #0097a7;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.notification-button.subscribed {
  background-color: var(--success-color);
}

/* Bookmarks link styles */
.bookmarks-link {
  background-color: white;
  color: var(--primary-color);
  text-decoration: none;
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  border: 2px solid var(--primary-color);
}

.bookmarks-link:hover {
  background-color: var(--primary-color);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.bookmarks-link i {
  font-size: 16px;
}

/* Search container styles */
.search-container {
  margin-bottom: 24px;
  position: relative;
}

#search-input {
  width: 100%;
  padding: 12px 20px;
  padding-left: 45px;
  border: 2px solid #e0e0e0;
  border-radius: 25px;
  font-size: 16px;
  transition: all 0.3s ease;
  background-color: white;
}

#search-input:focus {
  outline: none;
  border-color: var(--accent-color);
  box-shadow: 0 0 0 3px rgba(0, 188, 212, 0.1);
}

.search-container::before {
  content: '\\f002';
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #757575;
  font-size: 16px;
}

/* Navigation drawer */
.navigation-drawer {
  min-height: 100vh;
  width: 250px;
  padding: 20px;
  background-color: var(--primary-color);
  color: white;
  position: fixed;
  inset-block-start: 0;
  inset-inline-start: 0;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
  transform: translateX(-100%);
  transition: transform 350ms;
  z-index: 9999;
}

.navigation-drawer.open {
  transform: translateX(0);
}

.drawer-button {
  padding: 8px;
  border: 0;
  border-radius: 4px;
  display: inline-block;
  background-color: transparent;
  font-weight: bold;
  font-size: 28px;
  color: white;
  cursor: pointer;
}

.nav-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 30px;
}

.nav-list li a {
  padding: 10px 15px;
  display: block;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.nav-list li a:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Main content */
.main-content {
  padding-block: 30px;
  min-height: calc(100vh - 70px);
}

.page-title {
  margin-bottom: 30px;
  color: var(--primary-color);
  font-size: 2rem;
  border-bottom: 2px solid var(--secondary-color);
  padding-bottom: 10px;
}

/* Loading indicator */
.loading-indicator {
  display: none;
  position: relative;
  width: 50px;
  height: 50px;
  border: 5px solid var(--light-color);
  border-radius: 50%;
  border-top-color: var(--accent-color);
  margin: 20px auto;
  animation: spinner 1s linear infinite;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}

/* Status messages */
.status-message {
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 5px;
  text-align: center;
}

.status-message.success {
  background-color: rgba(46, 204, 113, 0.2);
  color: var(--success-color);
  border: 1px solid var(--success-color);
}

.status-message.error {
  background-color: rgba(231, 76, 60, 0.2);
  color: var(--danger-color);
  border: 1px solid var(--danger-color);
}

/* Form styles */
.auth-form,
.add-story-form {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  color: var(--dark-color);
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.form-group textarea {
  min-height: 120px;
  resize: vertical;
}

.form-group small {
  color: #888;
  font-size: 14px;
  margin-top: 5px;
  display: block;
}

.submit-button,
.button {
  background-color: var(--accent-color);
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: background-color 0.3s;
  display: inline-block;
  text-decoration: none;
  text-align: center;
}

.submit-button:hover,
.button:hover {
  background-color: #2980b9;
}

.auth-link {
  margin-top: 20px;
  text-align: center;
}

.auth-link a {
  color: var(--accent-color);
  text-decoration: none;
}

.auth-link a:hover {
  text-decoration: underline;
}

/* Camera container */
.camera-container {
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
}

#camera-preview,
#captured-image {
  width: 100%;
  max-width: 400px;
  border-radius: 5px;
  margin-bottom: 10px;
}

/* Map container */
.map-container {
  height: 400px;
  width: 100%;
  margin: 20px 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

#selected-location {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
}

/* Story items */
.stories-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

/* Bookmark page specific styles */
.bookmark-map {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.bookmarked-stories {
  position: relative;
  min-height: 200px;
}

.empty-message,
.error-message {
  text-align: center;
  padding: 40px 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.empty-message i,
.error-message i {
  font-size: 48px;
  color: var(--accent-color);
  margin-bottom: 16px;
}

.empty-message p,
.error-message p {
  font-size: 18px;
  color: #666;
}

.error-message i {
  color: var(--danger-color);
}

.story-item {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.story-item:hover {
  transform: translateY(-5px);
}

.story-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.story-content {
  padding: 15px;
}

.story-title {
  font-size: 1.25rem;
  margin-bottom: 8px;
  color: var(--dark-color);
}

.story-date {
  color: #777;
  font-size: 14px;
  margin-bottom: 10px;
}

.story-description {
  margin-bottom: 15px;
  line-height: 1.5;
}

.story-link {
  color: var(--accent-color);
  text-decoration: none;
  font-weight: bold;
  display: inline-block;
}

.story-link:hover {
  text-decoration: underline;
}

/* Story detail */
.story-full {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.story-image-full {
  width: 100%;
  max-height: 500px;
  object-fit: contain;
  border-radius: 5px;
  margin: 15px 0;
}

.story-actions {
  margin-top: 20px;
  display: flex;
  gap: 10px;
}

/* Map popup styling */
.popup-content {
  padding: 10px;
  max-width: 200px;
}

.popup-content h3 {
  margin-bottom: 8px;
  font-size: 1rem;
}

.popup-content img {
  width: 100%;
  border-radius: 4px;
  margin: 5px 0;
}

.popup-content p {
  font-size: 14px;
  margin-bottom: 5px;
}

.layer-control {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  background-color: white;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.layer-control select {
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 3px;
}

/* About page */
.about-content {
  background-color: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.about-content p {
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 1.7;
}

.features,
.tech-stack {
  margin: 30px 0;
}

.features h2,
.tech-stack h2 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: var(--primary-color);
}

.features ul,
.tech-stack ul {
  padding-left: 25px;
  margin-bottom: 15px;
}

.features li,
.tech-stack li {
  margin-bottom: 10px;
}

.features li {
  display: flex;
  align-items: center;
  gap: 10px;
}

.features li i {
  color: var(--secondary-color);
  font-size: 1.2rem;
}

/* View Transitions API */
@keyframes fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes slide-from-right {
  from {
    transform: translateX(30px);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes slide-to-left {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-30px);
  }
}

::view-transition-old(root) {
  animation: 300ms cubic-bezier(0.4, 0, 0.2, 1) both fade-out,
    300ms cubic-bezier(0.4, 0, 0.2, 1) both slide-to-left;
}

::view-transition-new(root) {
  animation: 300ms cubic-bezier(0.4, 0, 0.2, 1) both fade-in,
    300ms cubic-bezier(0.4, 0, 0.2, 1) both slide-from-right;
}

/* Media queries for responsive design */
@media screen and (width > 1000px) {
  .navigation-drawer {
    min-height: auto;
    width: auto;
    padding: 0;
    background-color: transparent;
    position: static;
    box-shadow: none;
    transform: translateX(0);
  }

  .nav-list {
    flex-direction: row;
    margin-top: 0;
  }

  .nav-list li a {
    display: inline-block;
  }

  .drawer-button {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .container {
    padding-inline: 15px;
  }

  .stories-container {
    grid-template-columns: 1fr;
  }

  .page-title {
    font-size: 1.7rem;
  }

  .map-container {
    height: 300px;
  }

  .auth-form,
  .add-story-form {
    padding: 15px;
  }

  .header-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .notification-button,
  .bookmarks-link {
    justify-content: center;
  }

  #search-input {
    font-size: 14px;
    padding: 10px 16px;
    padding-left: 40px;
  }

  .search-container::before {
    left: 15px;
    font-size: 14px;
  }
}

/* Not Found Page Styles */
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  animation: fadeIn404 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.not-found-illustration {
  margin-bottom: 24px;
  animation: float404 2.5s ease-in-out infinite alternate;
}

.not-found h2 {
  color: #2196f3;
  font-size: 2.2rem;
  margin-bottom: 8px;
}

.not-found p {
  color: #757575;
  margin-bottom: 20px;
}

.not-found .back-home {
  display: inline-block;
  padding: 10px 24px;
  background: #2196f3;
  color: #fff;
  border-radius: 24px;
  text-decoration: none;
  font-weight: 600;
  transition: background 0.2s;
}

.not-found .back-home:hover {
  background: #1769aa;
}

@keyframes fadeIn404 {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float404 {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(-16px);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,gCAAgC;AAClC;;;AAGA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,sCAAsC;EACtC,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,wCAAwC;EACxC,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA,gBAAgB;AAChB;;EAEE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;;EAEE,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;yDACuD;AACzD;;AAEA;EACE;4DAC0D;AAC5D;;AAEA,wCAAwC;AACxC;EACE;IACE,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["/* src/styles/styles.css */\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n:root {\r\n  --primary-color: #1a237e;\r\n  --secondary-color: #ff0000;\r\n  --accent-color: #00bcd4;\r\n  --light-color: #fafafa;\r\n  --dark-color: #121858;\r\n  --danger-color: #d32f2f;\r\n  --success-color: #388e3c;\r\n  --font-main: 'Arial', sans-serif;\r\n}\r\n\r\n\r\nbody {\r\n  font-family: var(--font-main);\r\n  line-height: 1.6;\r\n  color: #333;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n/* Skip link for accessibility */\r\n.skip-link {\r\n  position: absolute;\r\n  top: -40px;\r\n  left: 0;\r\n  z-index: 100;\r\n  width: 100%;\r\n  text-align: center;\r\n  transition: top 0.3s;\r\n}\r\n\r\n.skip-to-content {\r\n  background-color: var(--accent-color);\r\n  color: white;\r\n  padding: 8px 20px;\r\n  text-decoration: none;\r\n  border-radius: 0 0 5px 5px;\r\n}\r\n\r\n.skip-link:focus-within {\r\n  top: 0;\r\n}\r\n\r\n.container {\r\n  padding-inline: 32px;\r\n  margin-inline: auto;\r\n  max-width: 1300px;\r\n}\r\n\r\n/* Header styles */\r\nheader {\r\n  background-color: var(--primary-color);\r\n  color: white;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.main-header {\r\n  min-height: 70px;\r\n  padding-block: 15px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 30px;\r\n}\r\n\r\n.brand-name {\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n  text-decoration: none;\r\n  color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.brand-name i {\r\n  font-size: 1.75rem;\r\n}\r\n\r\n/* Header actions styles */\r\n.header-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n/* Notification button styles */\r\n.notification-button {\r\n  background-color: var(--accent-color);\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 25px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.notification-button:hover {\r\n  background-color: #0097a7;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.notification-button.subscribed {\r\n  background-color: var(--success-color);\r\n}\r\n\r\n/* Bookmarks link styles */\r\n.bookmarks-link {\r\n  background-color: white;\r\n  color: var(--primary-color);\r\n  text-decoration: none;\r\n  padding: 10px 20px;\r\n  border-radius: 25px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  transition: all 0.3s ease;\r\n  border: 2px solid var(--primary-color);\r\n}\r\n\r\n.bookmarks-link:hover {\r\n  background-color: var(--primary-color);\r\n  color: white;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.bookmarks-link i {\r\n  font-size: 16px;\r\n}\r\n\r\n/* Search container styles */\r\n.search-container {\r\n  margin-bottom: 24px;\r\n  position: relative;\r\n}\r\n\r\n#search-input {\r\n  width: 100%;\r\n  padding: 12px 20px;\r\n  padding-left: 45px;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 25px;\r\n  font-size: 16px;\r\n  transition: all 0.3s ease;\r\n  background-color: white;\r\n}\r\n\r\n#search-input:focus {\r\n  outline: none;\r\n  border-color: var(--accent-color);\r\n  box-shadow: 0 0 0 3px rgba(0, 188, 212, 0.1);\r\n}\r\n\r\n.search-container::before {\r\n  content: '\\f002';\r\n  font-family: 'Font Awesome 5 Free';\r\n  font-weight: 900;\r\n  position: absolute;\r\n  left: 20px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: #757575;\r\n  font-size: 16px;\r\n}\r\n\r\n/* Navigation drawer */\r\n.navigation-drawer {\r\n  min-height: 100vh;\r\n  width: 250px;\r\n  padding: 20px;\r\n  background-color: var(--primary-color);\r\n  color: white;\r\n  position: fixed;\r\n  inset-block-start: 0;\r\n  inset-inline-start: 0;\r\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);\r\n  transform: translateX(-100%);\r\n  transition: transform 350ms;\r\n  z-index: 9999;\r\n}\r\n\r\n.navigation-drawer.open {\r\n  transform: translateX(0);\r\n}\r\n\r\n.drawer-button {\r\n  padding: 8px;\r\n  border: 0;\r\n  border-radius: 4px;\r\n  display: inline-block;\r\n  background-color: transparent;\r\n  font-weight: bold;\r\n  font-size: 28px;\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.nav-list {\r\n  list-style: none;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n  margin-top: 30px;\r\n}\r\n\r\n.nav-list li a {\r\n  padding: 10px 15px;\r\n  display: block;\r\n  color: white;\r\n  text-decoration: none;\r\n  border-radius: 5px;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.nav-list li a:hover {\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n/* Main content */\r\n.main-content {\r\n  padding-block: 30px;\r\n  min-height: calc(100vh - 70px);\r\n}\r\n\r\n.page-title {\r\n  margin-bottom: 30px;\r\n  color: var(--primary-color);\r\n  font-size: 2rem;\r\n  border-bottom: 2px solid var(--secondary-color);\r\n  padding-bottom: 10px;\r\n}\r\n\r\n/* Loading indicator */\r\n.loading-indicator {\r\n  display: none;\r\n  position: relative;\r\n  width: 50px;\r\n  height: 50px;\r\n  border: 5px solid var(--light-color);\r\n  border-radius: 50%;\r\n  border-top-color: var(--accent-color);\r\n  margin: 20px auto;\r\n  animation: spinner 1s linear infinite;\r\n}\r\n\r\n@keyframes spinner {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* Status messages */\r\n.status-message {\r\n  padding: 15px;\r\n  margin-bottom: 20px;\r\n  border-radius: 5px;\r\n  text-align: center;\r\n}\r\n\r\n.status-message.success {\r\n  background-color: rgba(46, 204, 113, 0.2);\r\n  color: var(--success-color);\r\n  border: 1px solid var(--success-color);\r\n}\r\n\r\n.status-message.error {\r\n  background-color: rgba(231, 76, 60, 0.2);\r\n  color: var(--danger-color);\r\n  border: 1px solid var(--danger-color);\r\n}\r\n\r\n/* Form styles */\r\n.auth-form,\r\n.add-story-form {\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  background-color: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.form-group label {\r\n  display: block;\r\n  margin-bottom: 8px;\r\n  font-weight: bold;\r\n  color: var(--dark-color);\r\n}\r\n\r\n.form-group input,\r\n.form-group textarea {\r\n  width: 100%;\r\n  padding: 12px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n}\r\n\r\n.form-group textarea {\r\n  min-height: 120px;\r\n  resize: vertical;\r\n}\r\n\r\n.form-group small {\r\n  color: #888;\r\n  font-size: 14px;\r\n  margin-top: 5px;\r\n  display: block;\r\n}\r\n\r\n.submit-button,\r\n.button {\r\n  background-color: var(--accent-color);\r\n  color: white;\r\n  border: none;\r\n  padding: 12px 25px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  transition: background-color 0.3s;\r\n  display: inline-block;\r\n  text-decoration: none;\r\n  text-align: center;\r\n}\r\n\r\n.submit-button:hover,\r\n.button:hover {\r\n  background-color: #2980b9;\r\n}\r\n\r\n.auth-link {\r\n  margin-top: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.auth-link a {\r\n  color: var(--accent-color);\r\n  text-decoration: none;\r\n}\r\n\r\n.auth-link a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Camera container */\r\n.camera-container {\r\n  border: 1px solid #ddd;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  text-align: center;\r\n}\r\n\r\n#camera-preview,\r\n#captured-image {\r\n  width: 100%;\r\n  max-width: 400px;\r\n  border-radius: 5px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/* Map container */\r\n.map-container {\r\n  height: 400px;\r\n  width: 100%;\r\n  margin: 20px 0;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n#selected-location {\r\n  margin-top: 10px;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n/* Story items */\r\n.stories-container {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 20px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n/* Bookmark page specific styles */\r\n.bookmark-map {\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 8px;\r\n}\r\n\r\n.bookmarked-stories {\r\n  position: relative;\r\n  min-height: 200px;\r\n}\r\n\r\n.empty-message,\r\n.error-message {\r\n  text-align: center;\r\n  padding: 40px 20px;\r\n  background-color: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.empty-message i,\r\n.error-message i {\r\n  font-size: 48px;\r\n  color: var(--accent-color);\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.empty-message p,\r\n.error-message p {\r\n  font-size: 18px;\r\n  color: #666;\r\n}\r\n\r\n.error-message i {\r\n  color: var(--danger-color);\r\n}\r\n\r\n.story-item {\r\n  background-color: white;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.3s;\r\n}\r\n\r\n.story-item:hover {\r\n  transform: translateY(-5px);\r\n}\r\n\r\n.story-image {\r\n  width: 100%;\r\n  height: 200px;\r\n  object-fit: cover;\r\n}\r\n\r\n.story-content {\r\n  padding: 15px;\r\n}\r\n\r\n.story-title {\r\n  font-size: 1.25rem;\r\n  margin-bottom: 8px;\r\n  color: var(--dark-color);\r\n}\r\n\r\n.story-date {\r\n  color: #777;\r\n  font-size: 14px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.story-description {\r\n  margin-bottom: 15px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.story-link {\r\n  color: var(--accent-color);\r\n  text-decoration: none;\r\n  font-weight: bold;\r\n  display: inline-block;\r\n}\r\n\r\n.story-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Story detail */\r\n.story-full {\r\n  background-color: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.story-image-full {\r\n  width: 100%;\r\n  max-height: 500px;\r\n  object-fit: contain;\r\n  border-radius: 5px;\r\n  margin: 15px 0;\r\n}\r\n\r\n.story-actions {\r\n  margin-top: 20px;\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n/* Map popup styling */\r\n.popup-content {\r\n  padding: 10px;\r\n  max-width: 200px;\r\n}\r\n\r\n.popup-content h3 {\r\n  margin-bottom: 8px;\r\n  font-size: 1rem;\r\n}\r\n\r\n.popup-content img {\r\n  width: 100%;\r\n  border-radius: 4px;\r\n  margin: 5px 0;\r\n}\r\n\r\n.popup-content p {\r\n  font-size: 14px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.layer-control {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  z-index: 1;\r\n  background-color: white;\r\n  padding: 8px;\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.layer-control select {\r\n  padding: 5px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 3px;\r\n}\r\n\r\n/* About page */\r\n.about-content {\r\n  background-color: white;\r\n  padding: 25px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.about-content p {\r\n  margin-bottom: 20px;\r\n  font-size: 16px;\r\n  line-height: 1.7;\r\n}\r\n\r\n.features,\r\n.tech-stack {\r\n  margin: 30px 0;\r\n}\r\n\r\n.features h2,\r\n.tech-stack h2 {\r\n  font-size: 1.5rem;\r\n  margin-bottom: 15px;\r\n  color: var(--primary-color);\r\n}\r\n\r\n.features ul,\r\n.tech-stack ul {\r\n  padding-left: 25px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.features li,\r\n.tech-stack li {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.features li {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.features li i {\r\n  color: var(--secondary-color);\r\n  font-size: 1.2rem;\r\n}\r\n\r\n/* View Transitions API */\r\n@keyframes fade-in {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes fade-out {\r\n  from {\r\n    opacity: 1;\r\n  }\r\n\r\n  to {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n@keyframes slide-from-right {\r\n  from {\r\n    transform: translateX(30px);\r\n  }\r\n\r\n  to {\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n@keyframes slide-to-left {\r\n  from {\r\n    transform: translateX(0);\r\n  }\r\n\r\n  to {\r\n    transform: translateX(-30px);\r\n  }\r\n}\r\n\r\n::view-transition-old(root) {\r\n  animation: 300ms cubic-bezier(0.4, 0, 0.2, 1) both fade-out,\r\n    300ms cubic-bezier(0.4, 0, 0.2, 1) both slide-to-left;\r\n}\r\n\r\n::view-transition-new(root) {\r\n  animation: 300ms cubic-bezier(0.4, 0, 0.2, 1) both fade-in,\r\n    300ms cubic-bezier(0.4, 0, 0.2, 1) both slide-from-right;\r\n}\r\n\r\n/* Media queries for responsive design */\r\n@media screen and (width > 1000px) {\r\n  .navigation-drawer {\r\n    min-height: auto;\r\n    width: auto;\r\n    padding: 0;\r\n    background-color: transparent;\r\n    position: static;\r\n    box-shadow: none;\r\n    transform: translateX(0);\r\n  }\r\n\r\n  .nav-list {\r\n    flex-direction: row;\r\n    margin-top: 0;\r\n  }\r\n\r\n  .nav-list li a {\r\n    display: inline-block;\r\n  }\r\n\r\n  .drawer-button {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .container {\r\n    padding-inline: 15px;\r\n  }\r\n\r\n  .stories-container {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .page-title {\r\n    font-size: 1.7rem;\r\n  }\r\n\r\n  .map-container {\r\n    height: 300px;\r\n  }\r\n\r\n  .auth-form,\r\n  .add-story-form {\r\n    padding: 15px;\r\n  }\r\n\r\n  .header-actions {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    gap: 12px;\r\n  }\r\n\r\n  .notification-button,\r\n  .bookmarks-link {\r\n    justify-content: center;\r\n  }\r\n\r\n  #search-input {\r\n    font-size: 14px;\r\n    padding: 10px 16px;\r\n    padding-left: 40px;\r\n  }\r\n\r\n  .search-container::before {\r\n    left: 15px;\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n/* Not Found Page Styles */\r\n.not-found {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 60vh;\r\n  text-align: center;\r\n  animation: fadeIn404 0.8s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.not-found-illustration {\r\n  margin-bottom: 24px;\r\n  animation: float404 2.5s ease-in-out infinite alternate;\r\n}\r\n\r\n.not-found h2 {\r\n  color: #2196f3;\r\n  font-size: 2.2rem;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.not-found p {\r\n  color: #757575;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.not-found .back-home {\r\n  display: inline-block;\r\n  padding: 10px 24px;\r\n  background: #2196f3;\r\n  color: #fff;\r\n  border-radius: 24px;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.not-found .back-home:hover {\r\n  background: #1769aa;\r\n}\r\n\r\n@keyframes fadeIn404 {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(30px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes float404 {\r\n  from {\r\n    transform: translateY(0);\r\n  }\r\n\r\n  to {\r\n    transform: translateY(-16px);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
